import PropTypes from 'prop-types';

export const OECapBarPropTypes = {
    config: PropTypes.shape({
        available: PropTypes.bool,
        showInitially: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
        fullscreenBtn: PropTypes.bool
    })
};

export const OECapBarConfigFactory = {
    buildStdConfig()    {
        return {
            available: true,
            showInitially: true,
            fullscreenBtn: true
        };
    }
};